








































































/* eslint-disable @typescript-eslint/no-unused-vars */
import { defineComponent, ref } from '@vue/composition-api'
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'

import { required } from '@core/utils/validation'
import { useRouter } from '@core/utils'
import useAppConfig from '@core/@app-config/useAppConfig'
import useAuth from '../composables/useAuth'

export default defineComponent({
  setup() {
    // Template Ref
    const loginForm: any = ref(null)

    const { router } = useRouter()
    const { loginUser } = useAuth()
    const { isLoading } = useAppConfig()

    const isPasswordVisible = ref(false)

    const usuario = ref('')
    const password = ref('')

    const handleFormSubmit = async () => {
      const isFormValid = loginForm.value.validate()

      if (!isFormValid) return

      isLoading.value = true
      const { ok } = await loginUser({ usuario: usuario.value, password: password.value })

      if (ok) {
        router?.push('/')
      }

      isLoading.value = false
    }

    return {
      handleFormSubmit,

      isPasswordVisible,
      usuario,
      password,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      validators: {
        required,
      },

      // Template Refs
      loginForm,
    }
  },
})
